import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { Profile } from '@/components/Profile';
import VCProfile from '@/components/venture/VCProfile';
import BrandProfile from '@/components/brand/BrandProfile';
import AgentProfile from '@/components/agent/AgentProfile';
import TalentProfile from '@/components/talent/TalentProfile';
import { useUser } from '@/contexts/UserContext';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';
import { PageOnboardingTooltip, OnboardingSlide } from '@/components/onboarding/PageOnboardingTooltip';
import { User, Edit, Trophy, Star, Shield } from 'lucide-react';

const profileSlides: OnboardingSlide[] = [
  { icon: User, secondaryIcons: [Star], title: 'Your Profile', description: 'This is your public-facing profile. Brands, ventures, and other users see this when they discover you. Make it count!', gradient: 'from-primary/20 to-primary/5' },
  { icon: Edit, secondaryIcons: [Shield], title: 'Edit & Customize', description: 'Update your bio, social links, profile photo, and specializations. A complete profile increases your visibility and deal opportunities.', gradient: 'from-blue-500/20 to-blue-500/5' },
  { icon: Trophy, title: 'Tier Progress', description: 'Track your platform tier and achievements. Complete deals, grow your network, and unlock higher tiers for premium features and visibility.', gradient: 'from-emerald-500/20 to-emerald-500/5' },
];

const ProfilePage = () => {
  const { accountType } = useUser();
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader 
        title="Profile." 
        subtitle="Manage your account and preferences"
      />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <PageOnboardingTooltip storageKey="profile_tooltip_dismissed" slides={profileSlides} dialogTitle="Profile Walkthrough" />
        {accountType === 'venture' ? (
          <VCProfile />
        ) : accountType === 'brand' ? (
          <BrandProfile />
        ) : accountType === 'agent' ? (
          <AgentProfile />
        ) : accountType === 'talent' ? (
          <TalentProfile />
        ) : (
          <Profile />
        )}
      </div>
    </Layout>
  );
};

export default ProfilePage;